// extracted by mini-css-extract-plugin
module.exports = {"filtros":"Home_filtros__3SAHc","p":"Home_p__3hvX9","e":"Home_e__egKYu","create":"Home_create__1jMh9","cardscontainer":"Home_cardscontainer__10DMG"};